import React from 'react';
import { FiInbox, FiSend, FiFileText, FiTrash2, FiRefreshCw } from 'react-icons/fi';

const GMAIL_FOLDERS = [
  { id: 'INBOX', label: 'Inbox', icon: <FiInbox size={14} /> },
  { id: 'SENT',  label: 'Sent',  icon: <FiSend size={14} /> },
  { id: 'DRAFT', label: 'Drafts', icon: <FiFileText size={14} /> },
  { id: 'TRASH', label: 'Trash', icon: <FiTrash2 size={14} /> },
];

const ZOHO_FOLDERS = [
  { id: 'INBOX', label: 'Inbox', icon: <FiInbox size={14} /> },
  { id: 'SENT',  label: 'Sent',  icon: <FiSend size={14} /> },
  { id: 'DRAFT', label: 'Drafts', icon: <FiFileText size={14} /> },
  { id: 'TRASH', label: 'Trash', icon: <FiTrash2 size={14} /> },
];

const SMTP_FOLDERS = [
  { id: 'INBOX', label: 'Inbox', icon: <FiInbox size={14} /> },
  { id: 'SENT',  label: 'Sent',  icon: <FiSend size={14} /> },
  { id: 'DRAFT', label: 'Drafts', icon: <FiFileText size={14} /> },
  { id: 'TRASH', label: 'Trash', icon: <FiTrash2 size={14} /> },
];

const EmailSidebar = ({ accounts, activeSelection, onFolderChange, unreadCounts, onRefresh }) => (
  <div className="ec-sidebar">
    {accounts.map((account) => {
      const folders =
        account.type === 'gmail' ? GMAIL_FOLDERS :
        account.type === 'zoho' ? ZOHO_FOLDERS :
        SMTP_FOLDERS;
      const isActiveAccount = activeSelection?.accountId === account.id;

      return (
        <div key={account.id} className="ec-sidebar-account-section">
          <div className="ec-sidebar-account-label">
            <span className="ec-sidebar-account-name">{account.label}</span>
            {(account.type === 'gmail' || account.type === 'zoho') && (
              <button
                className="ec-sidebar-icon-btn"
                onClick={() => onRefresh(account.id)}
                title="Refresh"
              >
                <FiRefreshCw size={11} />
              </button>
            )}
          </div>

          {folders.map((f) => {
            const isActive = isActiveAccount && activeSelection?.folder === f.id;
            const unreadKey = `${account.id}:${f.id}`;
            const count = unreadCounts?.[unreadKey] || 0;

            return (
              <button
                key={f.id}
                className={`ec-folder-item${isActive ? ' active' : ''}`}
                onClick={() => onFolderChange({ accountId: account.id, folder: f.id })}
              >
                {f.icon}
                <span style={{ flex: 1 }}>{f.label}</span>
                {count > 0 && <span className="ec-folder-badge">{count}</span>}
              </button>
            );
          })}
        </div>
      );
    })}
  </div>
);

export default EmailSidebar;
